import React from "react";
import { HStack } from "@chakra-ui/react";
import JarIcon from "components/JarIcon";
import useTranslate from "hooks/useTranslate";
import FancyBearIcon from "components/FancyBearIcon";
import AssetStat from "components/AssetStat";
import { fancyBearsHoneyScalar, honeyJarsHoneyScalar } from "config";
import useAssets from "hooks/useAssets";

const WalletAssets: React.FC = () => {
  const translate = useTranslate();
  const { fancyBearsInWalletCount, honeyJarsInWalletCount } = useAssets();

  return (
    <HStack justify="stretch" gap="4">
      <AssetStat
        title={translate("header:bears:title")}
        icon={FancyBearIcon}
        value={fancyBearsInWalletCount}
        honeyScalar={fancyBearsHoneyScalar}
      />

      <AssetStat
        title={translate("header:jars:title")}
        icon={JarIcon}
        value={honeyJarsInWalletCount}
        honeyScalar={honeyJarsHoneyScalar}
      />
    </HStack>
  );
};

export default WalletAssets;
